var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTmPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.53218 3.99639L4.77028 1.00272C4.54545 0.620705 4.09596 0.432286 3.66593 0.539794L2.89989 0.731303C2.44861 0.844123 2.04542 1.09873 1.74958 1.4577C0.472962 3.00673 0.154155 5.13332 0.920414 6.9886L1.54816 8.50852C1.74269 8.97952 1.98083 9.43129 2.25947 9.85795L3.48545 11.7351C4.32101 13.0145 5.43866 14.0854 6.75257 14.8656L9.12744 16.2757L10.9819 17.0597C12.8111 17.833 14.916 17.5508 16.4769 16.323C16.8361 16.0405 17.0974 15.6524 17.2241 15.2134L17.4516 14.4253C17.5783 13.9866 17.3916 13.5178 16.9981 13.2862L14.0012 11.5224C13.5904 11.2806 13.0661 11.3624 12.7484 11.7178L11.4024 13.2237C11.169 13.4849 10.7784 13.5333 10.4883 13.337L8.61591 12.0701C7.67348 11.4325 6.8468 10.6386 6.17147 9.7228L4.57894 7.56315C4.35855 7.26427 4.4099 6.84531 4.69595 6.6085L6.30805 5.27389C6.68623 4.96081 6.7812 4.4195 6.53218 3.99639Z",
    fill: "#777777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.699 2.7093C17.0184 2.97297 17.0636 3.44568 16.7999 3.76513L13.0857 8.26512C12.9463 8.43403 12.74 8.53356 12.521 8.53757C12.302 8.54158 12.0922 8.44966 11.9467 8.28597L9.66099 5.71455C9.38581 5.40496 9.41369 4.93091 9.72328 4.65572C10.0329 4.38053 10.5069 4.40842 10.7821 4.718L12.4862 6.63506L15.6431 2.81029C15.9068 2.49084 16.3795 2.44562 16.699 2.7093Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTmPhone);
export default __webpack_public_path__ + "static/media/tm_phone.ca0861fa977219d1f7013d63b260ea43.svg";
export { ForwardRef as ReactComponent };